import { GOOGLE_MAPS_MAP_ID } from "@/constants";
import { useEffect, useRef, useState } from "react";

export function useGoogleMaps(initialBounds: () => google.maps.LatLngBounds) {
  const mapContainerRef$ = useRef<HTMLDivElement>(null);
  const [mapInstance, setMapInstance] = useState<google.maps.Map>();

  useEffect(() => {
    if (null === mapContainerRef$.current) {
      return;
    }

    const bounds = initialBounds();

    const currentInstance = new google.maps.Map(mapContainerRef$.current, {
      clickableIcons: false,
      disableDefaultUI: true,
      mapId: GOOGLE_MAPS_MAP_ID,
      renderingType: google.maps.RenderingType.VECTOR,
      zoom: 13,
      center: bounds.getCenter(),
    });

    currentInstance.fitBounds(bounds);
    setMapInstance(currentInstance);
  }, []);

  return [mapContainerRef$, mapInstance] as const;
}
